import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Modal,
  Button,
  Spinner,
  FormLabel,
} from "react-bootstrap";
import axios from "axios";
import "./ContactForm.css";
import InputGroup from "react-bootstrap/InputGroup";
import { AiOutlineCalendar } from "react-icons/ai";
import one from "../../Images/one-on-one.webp";
import commenticon from "../../Images/commenticon.webp";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import { FaUserTie } from "react-icons/fa";

function trim(theStr) {
  return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}

function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
  var retVal = "";
  var okChars = "0123456789";
  var tmpVal = trim(inVal);
  var curChar = "";
  var isDotFound = false;

  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);

      if (okChars.indexOf(curChar) !== -1) {
        if (!isDotFound && curChar === "." && isDouble) {
          isDotFound = true;
          retVal = retVal + ".";
        }

        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }

  return retVal;
}

function serialize(form) {
  let inputs = form.elements;
  let testArray = {};
  for (let i = 0; i < inputs.length - 1; i++) {
    testArray[inputs[i].id] = inputs[i].value;
  }
  return testArray;
}

function getFormURL() {
  if (
    window.location.href.split("/")[3] &&
    window.location.href.split("/")[4]
  ) {
    const temp = window.location.href.split("/")[4].replace("#", "");
    return "/" + window.location.href.split("/")[3] + "/" + temp;
  } else {
    return "/";
  }
}

export default function SignUpForm({ formData }) {
  const imgCDNURL = process.env.REACT_APP_AIWORKSHOPFEEDBACK_CDN_URL;
  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [leadNo, setLeadNo] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [consentValue, setConsentValue] = useState(true);
  const [showContactForm, setShowContactForm] = useState(true);
  const [showConsenSection, setShowConsenSection] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const [showClickToMoreOpt, setShowClickToMoreOpt] = useState(true);
  const [joiningValue, setJoiningValue] = useState("");
  const [joiningValue1, setJoiningValue1] = useState("");
  const [joiningValue2, setJoiningValue2] = useState("");
  const [memoBox, setMemoBox] = useState("");
  const [memoBox1, setMemoBox1] = useState("");
  const [memoBox2, setMemoBox2] = useState("");
  const [interested, setInterested] = useState(false);
  const [preferredDate, setPreferredDate] = useState("");
  const [preferredTime, setPreferredTime] = useState("");
  const [preferredAmPm, setPreferredAmPm] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    errMsg: "",
    showError: false,
  });
  const [contactNumberRequired, setContactNumberRequired] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [optedForTextMessage, setOptedForTextMessage] = useState(false);
  const [referrerName, setReferrerName] = useState("");
  const [comment, setComment] = useState("");
  const [datetime, setDatetime] = useState("");
  const [message, setMessage] = useState("");
  const [state, setState] = useState("");
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [validationNote, setValidationNote] = useState("");
  const [minTime, setMinTime] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  const [disabledTimes, setDisabledTimes] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [titleError, setTitleError] = useState(false);

  const handleTitleChange = (e) => {
    setSelectedTitle(e.target.value);
    setTitleError(false); // Reset the error when a valid option is selected
  };
  

  // useEffect(() => {
  //   const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   const isCustomTimezone = customTimezoneOptions.some(option => option.value === userTimezone);

  //   if (isCustomTimezone) {
  //     setSelectedTimezone(userTimezone);

  //   } else {
  //     // If user's timezone is not in the custom options, default to Pacific Time
  //     setSelectedTimezone('Pacific Time (PT)');

  //   }
  // }, []); // Run only once on component mount

  useEffect(() => {
    const todayStart = moment().startOf("day");
    const tenAM = moment(todayStart).set({ hour: 10, minute: 0 });
    const fivePM = moment(todayStart).set({ hour: 17, minute: 0 });

    const currentTime = moment();
    const selectedDate = moment(selectedDateTime).startOf("day");

    let min = null;
    let max = null;

    if (selectedDate.isSame(todayStart)) {
      min = currentTime.isSameOrAfter(tenAM)
        ? currentTime.toDate()
        : tenAM.toDate();
      max = fivePM.toDate();
    } else {
      min = tenAM.toDate();
      max = fivePM.toDate();
    }

    setMinTime(min);
    setMaxTime(max);

    // Disable past time slots
    const times = [];
    let current = moment(min);

    while (current.isSameOrBefore(max)) {
      times.push(current.clone().toDate());
      current.add(1, "hour");
    }

    const disabled = times.filter((time) => currentTime.isAfter(moment(time)));
    setDisabledTimes(disabled);
  }, [selectedDateTime]);

  // Custom options list with selected timezones
  const customTimezoneOptions = [
    { value: "Pacific Time (PT)", label: "(GMT-8:00) Pacific Time (PT)" },
    {
      value: "Hawaii-Aleutian Time (HST)",
      label: "(GMT-10:00) Hawaii-Aleutian Time (HST)",
    },
    { value: "Alaska Time (AKT)", label: "(GMT-9:00) Alaska Time (AKT)" },
    { value: "Mountain Time (MT)", label: "(GMT-7:00) Mountain Time (MT)" },
    { value: "Central Time (CT)", label: "(GMT-6:00) Central Time (CT)" },
    { value: "Eastern Time (ET)", label: "(GMT-5:00) Eastern Time (ET)" },
    { value: "Atlantic Time (AT)", label: "(GMT-4:00) Atlantic Time (AT)" },
  ];

  const handleInterestedChange = (event) => {
    // console.log(event, "JONI");
    if (event.target.value === "Yes") {
      setInterested(true);
      setPhone("");
      setContactNumberRequired(true);
      setPreferredAmPm("");
    } else {
      setInterested(false);
      setPreferredDate("");
      setPreferredTime("");
      setPreferredAmPm("");
      setContactNumberRequired(false);
    }
  };
  const selectjoiningvalue = () => {
    setJoiningValue2("Yes");
    setInterested(true);
    setPhone("");
    setContactNumberRequired(true);
    setPreferredAmPm("");
  };

  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get("key");
  const utmSource = queryParams.get("utm_source") || undefined;
  const utmMedium = queryParams.get("utm_medium") || undefined;
  const utmCampaign = queryParams.get("utm_campaign") || undefined;
  const utmContent = queryParams.get("utm_content") || undefined;
  const handleFailClose = () => {
    setShowFailModal(false);
    setValidated(false);
  };
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setValidated(false);
  };

  const clearForm = () => {
    setLeadNo("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setJoiningValue("");
    setJoiningValue1("");
    setJoiningValue2("");
    setMemoBox("");
    setMemoBox1("");
    setMemoBox2("");
    setPreferredDate("");
    setPreferredTime("");
    setPreferredAmPm("");
    setTimeZone("");
    setErrorMessage("");
    setContactNumberRequired("");
    setSubmitted("");
    setInterested("");
    setComment("");
    setMessage("");
    setState("");
    setReferrerName("");
    setSelectedDateTime(null);
    setSelectedTimezone("");
    setOptedForTextMessage("");
    setConsentValue(true);
    setValidationNote("");
    setSelectedTitle("")
  };

  const goBackToFirstPage = () => setShowConsenSection(false);

  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }

  //first name validation
  const handleFirstName = (evt) => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      setFirstName(tempFirstName.trim());
    } else {
      setFirstName("");
    }
  };

  const handleRadioClick = () => {
    setOptedForTextMessage(!optedForTextMessage);
  };

  const handleReferrerName = (e) => {
    setReferrerName(e.target.value);
  };

  //     if (tempFirstName.includes(" ") && lastName === "") {
  //       const name = tempFirstName.split(" ");
  //       let fName = name[0];
  //       let lName = name.slice(1).join(" ");
  //       setFirstName(fName.trim());
  //       setLastName(lName.trim());
  //     } else {
  //       setFirstName(tempFirstName.trim());
  //     }
  //   } else {
  //     setFirstName("");
  //   }
  // };

  //last name validation
  // const handleLastName = (evt) => {
  //   let tempLastName = evt.currentTarget.value;
  //   tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
  //   if (tempLastName) {
  //     if (tempLastName.includes(" ") && firstName === "") {
  //       const name = tempLastName.split(" ");
  //       let fName = name[0];
  //       let lName = name.slice(1).join(" ");
  //       setFirstName(fName.trim());
  //       setLastName(lName.trim());
  //     } else {
  //       setLastName(tempLastName.trim());
  //     }
  //   } else {
  //     setLastName("");
  //   }
  // };

  const handleEmailAddress = (evt) => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  // Phone number validation
  const handleTelephoneNumber = (evt) => {
    //Save Phone number in local storage for Apply
    var tmpVal = trim(getNumbers(evt.currentTarget.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
            456, 555, 900,
            100, 101, ..., 199
            211, 311, ..., 911  ***811 removed
            370, 371, ..., 379
            960, 961, ..., 969
            800, 801, ..., 855  ***removed
            866, 877, 888, 800855
            */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }

    var curChar = "";
    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    /* Do not put the parentesis if we only have the first three digits of the phone number.
            Once we are past that then start formatting the phone number. This was the main issue
            why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== "" && firstThree === "") retVal += areaCode;
    else if (areaCode !== "" && firstThree !== "")
      retVal += "(" + areaCode + ")";

    if (firstThree !== "") retVal += " " + firstThree;

    if (lastFour !== "") retVal += "-" + lastFour;

    if (extension !== "") retVal += " x" + extension;
    else setPhone(retVal);
  };

  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };

  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };

  const handleDateTimeChange = (date) => {
    const todayStart = moment().startOf("day");
    const selectedStart = moment(date).startOf("day");

    if (selectedDateTime === null) {
      const defaultTime = moment(date).set({ hour: 10, minute: 0 }).toDate();
      setSelectedDateTime(defaultTime);
    } else if (selectedStart.isSame(todayStart, "day")) {
      const currentTime = moment();
      const tenAM = moment(selectedStart).set({ hour: 10, minute: 0 });
      const fivePM = moment(selectedStart).set({ hour: 17, minute: 0 });

      let selectedTime = null;

      if (currentTime.isBefore(tenAM)) {
        // If the current time is before 10 am, select the chosen time
        selectedTime = moment(date).toDate();
      } else if (currentTime.isBetween(tenAM, fivePM)) {
        selectedTime = moment(date).toDate();
      } else {
        // If the current time is after 5 pm, select the next working day at 10 am
        let nextWorkingDay = todayStart.clone().add(1, "day");

        // Loop until the next working day is found (skipping weekends)
        while (nextWorkingDay.isoWeekday() > 5) {
          nextWorkingDay.add(1, "day");
        }

        const nextWorkingTime = moment(nextWorkingDay)
          .set({ hour: 10, minute: 0 })
          .toDate();
        selectedTime = nextWorkingTime;
      }

      setSelectedDateTime(selectedTime);
    } else {
      setSelectedDateTime(date);
    }
  };

  const handleTimezoneChange = (event) => {
    setSelectedTimezone(event.target.value);
  };

  // const getPSTTime = (date, timezone) => {
  //   // Format the selected date and time based on the provided 'date' parameter
  //   const formattedDateTime = moment(date).format("YYYY-MM-DD HH:mm");

  //   // Convert the formatted date and time to the specified timezone
  //   const selectedDateTimeInSelectedTimezone = moment.tz(formattedDateTime, timezone);

  //   // Convert the selected date and time to PST (America/Los_Angeles)
  //   const pstDateTime = selectedDateTimeInSelectedTimezone.clone().tz("Pacific Time (PT)");

  //   // Format the PST datetime as needed ('YYYY-MM-DD HH:mm:ss')
  //   const pstTimeFormatted = pstDateTime.format("YYYY-MM-DD HH:mm:ss");

  //   return pstTimeFormatted;
  // };

  const getTimezoneLabel = (timezoneValue) => {
    const timezoneOptions = [
      { value: "Pacific Time (PT)", label: "(GMT-8:00) Pacific Time (PT)" },
      {
        value: "Hawaii-Aleutian Time (HST)",
        label: "(GMT-10:00) Hawaii-Aleutian Time (HST)",
      },
      { value: "Alaska Time (AKT)", label: "(GMT-9:00) Alaska Time (AKT)" },
      { value: "Mountain Time (MT)", label: "(GMT-7:00) Mountain Time (MT)" },
      { value: "Central Time (CT)", label: "(GMT-6:00) Central Time (CT)" },
      { value: "Eastern Time (ET)", label: "(GMT-5:00) Eastern Time (ET)" },
      { value: "Atlantic Time (AT)", label: "(GMT-4:00) Atlantic Time (AT)" },
    ];

    const selectedOption = timezoneOptions.find(
      (option) => option.value === timezoneValue
    );
    return selectedOption ? selectedOption.label : ""; // Return label based on the value
  };

  const dateValidation = (val) => {
    const userDate = val;
    const userEpochTime = Date.parse(userDate) / 1000;
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const currentEpochTime = Math.floor(currentDate.getTime() / 1000);

    if (!userDate) {
      setPreferredDate("");
      return false;
    } else if (userEpochTime >= currentEpochTime) {
      setPreferredDate(val);
      return true;
    } else {
      setPreferredDate(val);
      return false;
    }
  };
  const timeValidation = () => {
    if (!preferredTime || !preferredAmPm) {
      return false;
    }
    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    // date and time validation start
    const form = event.currentTarget;
    const currentTimes = moment();
    const selectedTime = moment(selectedDateTime);

    const todayStart = moment().startOf("day");
    const selectedStart = moment(selectedDateTime).startOf("day");

    if (joiningValue2 === "Yes") {
      // Only proceed if joiningValue2 is "Yes"
      if (!selectedDateTime) {
        setValidationNote("Please select date/hour.");
        return;
      }
    }
    // if (
    //   selectedStart.isSame(todayStart, 'day') &&
    //   selectedTime.isBefore(currentTimes)
    // ) {
    //   alert("Cannot select a past time for today.");
    //   return;
    // }
    // let pstTime; // Declare pstTime variable outside of the if block

    // if (joiningValue2 === "Yes") {
    //   if (selectedDateTime && selectedTimezone) {
    //     pstTime = getPSTTime(selectedDateTime, selectedTimezone);
    //     // console.log("Selected Date and Time in PST:", pstTime);
    //     setValidationNote("");
    //   } else {
    //     setValidationNote("");
    //   }
    // }

    // date validation end

    // Validate if a title is selected
    // if (!selectedTitle) {
    //   setTitleError(true);
    //   return;
    // }

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setFormLoading(true);
      const signupFormData = document.querySelector("#signupForm");
      const getData = serialize(signupFormData);
      const signupForm = document.getElementById("signupForm");
      if (!showConsenSection) {
        // const firstName_ = getData.firstName;
        let tempname = getData.firstName;
        let firstName_, lastName_;
        if (tempname.includes(" ")) {
          const name = tempname.split(" ");
          firstName_ = name[0];
          lastName_ = name.slice(1).join(" ");
          lastName_ = lastName_.trim();
        } else {
          firstName_ = tempname;
        }
        firstName_ = firstName_.trim();
        // const lastName_ = getData.lastName;
        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const title_ = selectedTitle;
        const companyName_ = "";
        const joiningvalue_ = joiningValue;
        const joiningvalue1_ = joiningValue1;
        const joiningvalue2_ = joiningValue2;
        const memoBox_ = memoBox;
        const memoBox1_ = memoBox1;
        const memoBox2_ = memoBox2;
        const options = {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        };
        const selectedDateTime_ = interested
          ? selectedDateTime.toLocaleString("en-US", options)
          : "";
        const selectedTimezone_ = interested ? selectedTimezone : "";
        const preferredAmPm_ = interested ? preferredAmPm : "";
        const timeZone_ = interested ? timeZone : "";
        const state_ = getData.state;

        let formUrl = getFormURL();
        const chs_name = getData["chs:name"];
        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            firstName: firstName_ ? firstName_ : " ",
            lastName: lastName_ ? lastName_ : " ",
            phone: phoneNumber_ ? phoneNumber_ : " ",
            email: email_ ? email_ : " ",
            companyName: title_ ? title_: "",
            referrerSource: "AI WORKSHOP FEEDBACK",
            comments: 
            `Q.1 Was the Ai workshop helpful to you?: "${joiningvalue_}"  \nComment Box1 : "${memoBox_}"\n\
            Q.2 What topics would you like us to cover in future workshops? \nComment Box2: "${memoBox1_}"\n\
            Q.3 Are you interested in scheduling an additional Ai coaching with us? "${joiningvalue2_}"
            ${interested ? `"Preferred Date: ${selectedDateTime_}" "Preferred TimeZone:" ${selectedTimezone_}` : ''}
            \nComment Box3 : "${memoBox2_}"`,
            "chs:name": chs_name,
            utmSource: utmSource,
            utmMedium: utmMedium,
            utmCampaign: utmCampaign,
            utmContent: utmContent,
            formUrl: formUrl,
            leadSource: "AIWORKSHOPFEEDBACK",
            TCPA_Consent_Given: consentValue,
          })
          .then((res) => {
            setLeadNo(res.data.success.brokerId);
            // show the consent section.
            setShowConsenSection(true);
            setFormLoading(false);
          })
          .catch(function (error) {
            setShowFailModal(true);
            setShowSuccessModal(false);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            setFormLoading(false);
          });
      } else {
        // We need to update the details of lead again as there might be the case user may
        // select I do not consent in the consent section after lead is generated
        const leadNo_ = getData.leadNo;
        // const firstName_ = getData.firstName;
        // const lastName_ = getData.lastName;
        let tempname = getData.firstName;
        let firstName_, lastName_;
        if (tempname.includes(" ")) {
          const name = tempname.split(" ");
          firstName_ = name[0];
          lastName_ = name.slice(1).join(" ");
          lastName_ = lastName_.trim();
        } else {
          firstName_ = tempname;
        }
        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const title_ = selectedTitle;
        // const comment_ = getData.comment;
        const joiningvalue_ = joiningValue;
        const joiningvalue1_ = joiningValue1;
        const joiningvalue2_ = joiningValue2;
        const memoBox_ = memoBox;
        const memoBox1_ = memoBox1;
        const memoBox2_ = memoBox2;
        const options = {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        };
        const selectedDateTime_ = interested
          ? selectedDateTime.toLocaleString("en-US", options)
          : "";
        const selectedTimezone_ = interested ? selectedTimezone : "";
        const preferredAmPm_ = interested ? preferredAmPm : "";
        const timeZone_ = interested ? timeZone : "";
        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            leadId: leadNo_,
            firstName: firstName_ ? firstName_ : " ",
            lastName: lastName_ ? lastName_ : " ",
            phone: phoneNumber_ ? phoneNumber_ : " ",
            email: email_ ? email_ : " ",
            companyName: title_ ? title_: "",
            comments:
            `Q.1 Was the Ai workshop helpful to you?: "${joiningvalue_}"  \nComment Box1 : "${memoBox_}"\n\
            Q.2 What topics would you like us to cover in future workshops? \nComment Box2: "${memoBox1_}"\n\
            Q.3 Are you interested in scheduling an additional Ai coaching with us? "${joiningvalue2_}"
            ${interested ? `"Preferred Date: ${selectedDateTime_}" "Preferred TimeZone:" ${selectedTimezone_}` : ''}
            \nComment Box3 : "${memoBox2_}"`,
            leadSource: "AIWORKSHOPFEEDBACK",
            TCPA_Consent_Given: consentValue,
          })

          .then((res) => {
            setLeadNo(leadNo_);
            setShowContactForm(true);
            setShowConsenSection(false);
            setShowSuccessModal(true);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            clearForm();
            setFormLoading(false);
          })
          .catch(function (error) {
            setShowFailModal(true);
            setShowSuccessModal(false);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            setFormLoading(false);
          });
      }
    }
    setValidated(true);
  };

  useEffect(() => {
    if (selectedDateTime) {
      setValidationNote("");
    }
  }, [selectedDateTime]);

  useEffect(() => {
    const getTimeZone = () => {
      const now = new Date();
      const timeZone = moment.tz.guess();
      const timeZoneLabel = moment().tz(timeZone).format("z");

      setTimeZone(timeZoneLabel);
    };

    getTimeZone();

    if (key) {
      axios
        .post(
          process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY,
          { key: key },
          {
            headers: { "Content-Type": "text/html" },
          }
        )
        .then((response) => {
          let userData = response.data.parameters;
          if (userData.borrowerName) {
            // If the borrower name contains a space, split the first and last name.
            let name = userData.borrowerName.split(" ");
            setFirstName(name[0]);
            // setLastName(name.slice(1).join(" "));
          } else {
            // If there is no borrower name, set the first and last name accordingly.
            if (userData.borrowerFirstName) {
              setFirstName(userData.borrowerFirstName);
            }
            // if (userData.borrowerLastName) {
            //   setLastName(userData.borrowerLastName);
            // }
          }
          setPhone(userData.borrowerPhone);
          setEmail(userData.emailAddress);

          return response;
        })
        .catch((error) => {
          console.error("Get GET_SESSION_KEY Error: ", error);
        });
    }
  }, []);

  const CustomDatePickerInput = ({ value, onClick }) => {
    return (
      <input
        className="form-control date-picker-input"
        value={value}
        onClick={onClick}
        placeholder="Select Date and Hour"
        readOnly // Make the input field read-only for mobile devices
      />
    );
  };

  return (
    <>
      <div className="formWrapper pad-form">
        <div className="formBody">
          <Container className="form-container pt-3">
            <Row>
              <Col>
                {showContactForm && (
                  <Form
                    id="signupForm"
                    autoComplete="off"
                    method="POST"
                    noValidate
                    onSubmit={handleSubmit}
                    validated={validated}
                  >
                    <Row>
                      <Col sm={12} className="d-none">
                        <Form.Group controlId="leadNo" className="form-group">
                          <Form.Control
                            aria-label="Lead Number"
                            placeholder="Lead Number"
                            type="text"
                            value={leadNo}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        {/* <InputGroup className=""> */}

                        <FormLabel id="joining-radio">
                          {" "}
                          Was the Ai workshop helpful to you?*
                        </FormLabel>
                        <div id="group1" className="d-flex mt-2">
                          <Form.Check
                            label="Yes"
                            aria-label="Yes"
                            type="radio"
                            value="Yes"
                            required
                            name="group1"
                            className="inputoption"
                            id="firstquestion"
                            onClick={() => setJoiningValue("Yes")}
                          />
                          <Form.Check
                            required
                            label="No"
                            aria-label="No"
                            type="radio"
                            value="No"
                            name="group1"
                            className="inputoption"
                            onClick={() => setJoiningValue("No")}
                          />
                        </div>
                        {/* </InputGroup> */}
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <img
                          src={imgCDNURL + "formg1.webp"}
                          className="user formg1"
                        />
                        <Form.Group controlId="memobox" className="form-group1">
                          <Form.Control
                            rows="3"
                            id="memobox"
                            aria-label="Comment Box1"
                            placeholder="Add your comments"
                            as="textarea"
                            value={memoBox}
                            onChange={(e) => setMemoBox(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                        id="Questiontwo"
                      >
                        <FormLabel id="joining-radio2">
                          {" "}
                          What topics would you like us to cover in future
                          workshops?
                        </FormLabel>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <img
                          src={imgCDNURL + "formg2.webp"}
                          className="user formg2"
                        />
                        <Form.Group controlId="memobox" className="form-group2">
                          <Form.Control
                            rows="3"
                            id="memobox"
                            aria-label="Comment Box2"
                            placeholder="Add your comments"
                            as="textarea"
                            value={memoBox1}
                            onChange={(e) => setMemoBox1(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <FormLabel id="joining-radio3">
                          {" "}
                          Are you interested in scheduling an additional Ai
                          coaching with us?*
                        </FormLabel>
                        <img src={one} className="user formg3" />
                        <div id="group3" className="d-flex mt-2">
                          <Form.Check
                            required
                            label="Yes"
                            aria-label="Yes"
                            type="radio"
                            value="Yes"
                            name="group3"
                            className="inputoption"
                            onClick={() => selectjoiningvalue()}
                            onChange={handleInterestedChange}
                          />

                          <Form.Check
                            required
                            label="No"
                            aria-label="No"
                            type="radio"
                            value="No"
                            name="group3"
                            className="inputoption"
                            onClick={() => setJoiningValue2("No")}
                            onChange={handleInterestedChange}
                          />
                        </div>

                        {interested && (
                          <div className="fieldsection">
                            {/* <img src={imgCDNURL + "email.webp"} className="icons" /> */}
                            <AiOutlineCalendar className="custom-icon-calender" />
                            <FormLabel className="date-text">
                              Preferred Date*:
                            </FormLabel>
                            <div className="date-timezone">
                              <DatePicker
                                selected={selectedDateTime}
                                onChange={handleDateTimeChange}
                                showTimeSelect
                                timeIntervals={60}
                                // locale="en-GB"
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeFormat="h:mm aa"
                                timeCaption="Time"
                                timezone={selectedTimezone}
                                placeholderText="Select Date and Hour"
                                dropdownMode="select"
                                required
                                value={selectedDateTime}
                                minDate={moment().startOf("day").toDate()}
                                minTime={minTime}
                                maxTime={maxTime}
                                filterDate={(date) => {
                                  const today = moment().startOf("day");
                                  const selectedDate =
                                    moment(date).startOf("day");
                                  const currentTime = moment();

                                  const fivePM = moment(today).set({
                                    hour: 17,
                                    minute: 0,
                                  });

                                  // Filter out Saturday and Sunday
                                  if (selectedDate.isoWeekday() >= 6) {
                                    return false;
                                  }

                                  // Disable dates after 5 PM for today

                                  if (
                                    selectedDate.isSame(today) &&
                                    currentTime.isAfter(fivePM)
                                  ) {
                                    return false;
                                  }

                                  return true;
                                }}
                                filterTime={(time) => {
                                  return !disabledTimes.find((disabledTime) =>
                                    moment(disabledTime).isSame(time, "minute")
                                  );
                                }}
                                customInput={
                                  <CustomDatePickerInput className="date-picker-input" />
                                }
                              ></DatePicker>
                               {validationNote && (
                              <p className="validation-note">
                                {validationNote}
                              </p>
                            )}
                              <div className="time-input-container">
                                <Form.Group
                                  controlId="timezoneDropdown"
                                  className="time-input-container"
                                >
                                  <Form.Control
                                    as="select"
                                    value={selectedTimezone}
                                    onChange={handleTimezoneChange}
                                    className="form-control custom-select"
                                    required
                                  >
                                    <option value="" disabled>
                                      Select Time Zone
                                    </option>
                                    {customTimezoneOptions.map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </Form.Control>
                                  <Form.Control.Feedback type="invalid" className="timezone-error">
                                    Please select timezone.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                            </div>
                          </div>
                        )}
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        {/* <BiCommentDetail size={24} color="#023F88" /> */}
                        <img src={commenticon} className="commenticon"></img>
                        <Form.Group controlId="memobox" className="form-group3">
                          <Form.Control
                            rows="3"
                            id="memobox"
                            aria-label="Comment Box3"
                            placeholder="Add your comments"
                            as="textarea"
                            value={memoBox2}
                            onChange={(e) => setMemoBox2(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col
                      sm={12}
                      className={showConsenSection ? "d-none" : "d-block"}
                      >
                         <div className="title-input-container">
      <Form.Group className="d-flex flex-wrap align-items-center form-group" controlId="comment">
        <Form.Label className="d-flex align-items-center mb-0 me-2 fw-bold fs-6">
          <FaUserTie className="icon-spacing" />I am:
        </Form.Label>
        <div className="w-100 custom-margin">
  <div className="row">
    <div className="col-md-4 col-lg-4 col-xl-4 col-6">
      <Form.Check
        type="radio"
        id="realtor"
        label="Realtor"
        name="title"
        value="Realtor"
        onChange={handleTitleChange}
        checked={selectedTitle === "Realtor"}
        isInvalid={titleError}
        onClick={() => setSelectedTitle("Realtor")}
        className="w-100"
      />
    </div>
    <div className="col-md-5 col-lg-6 col-xl-6 col-12">
      <Form.Check
        type="radio"
        id="loan-originator"
        label="Loan Originator"
        name="title"
        value="Loan Originator"
        onChange={handleTitleChange}
        checked={selectedTitle === "Loan Originator"}
        isInvalid={titleError}
        onClick={() => setSelectedTitle("Loan Originator")}
        className="w-100"
      />
    </div>
    <div className="col-md-4 col-lg-4 col-xl-4 col-12">
      <Form.Check
        type="radio"
        id="other"
        label="Other"
        name="title"
        value="Other"
        onChange={handleTitleChange}
        checked={selectedTitle === "Other"}
        isInvalid={titleError}
        onClick={() => setSelectedTitle("Other")}
        className="w-100"
      />
    </div>
    <div className="col-md-5 col-lg-6 col-xl-6 col-12">
      <Form.Check
        type="radio"
        id="home-builder"
        label="Home Builder"
        name="title"
        value="Home Builder"
        onChange={handleTitleChange}
        checked={selectedTitle === "Home Builder"}
        isInvalid={titleError}
        onClick={() => setSelectedTitle("Home Builder")}
        className="w-100"
      />
    </div>
  </div>
</div>


        <Form.Control.Feedback type="invalid" className="ms-3">
          Please select a title.
        </Form.Control.Feedback>
      </Form.Group>
    </div>
                      </Col>
                      <Col
                        sm={12}
                        // md={6}
                        // lg={6}
                        // xl={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group
                          controlId="firstName"
                          className="form-group"
                        >
                          <InputGroup className="">
                            <img
                              src={imgCDNURL + "name.webp"}
                              className="icons"
                            />

                            <Form.Control
                              aria-label="Name"
                              onChange={(e) => setFirstName(e.target.value)}
                              onBlur={handleFirstName}
                              placeholder="Name:*"
                              required={lastName === ""}
                              type="text"
                              value={firstName}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      {/* <Col
                        sm={12}
                        md={6}
                        lg={6}
                        xl={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="lastName" className="form-group">
                          <Form.Control
                            aria-label="Last Name"
                            onChange={(e) => setLastName(e.target.value)}
                            onBlur={handleLastName}
                            placeholder="Last Name"
                            required={firstName === ""}
                            type="text"
                            value={lastName}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid Last Name.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col> */}
                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        lg={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="email" className="form-group">
                          <InputGroup className="">
                            <img
                              src={imgCDNURL + "email.webp"}
                              className="icons"
                            />
                            <Form.Control
                              aria-label="Email ID"
                              onChange={handleEmailAddress}
                              pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]{2,64})$"
                              placeholder="Email ID:*"
                              required
                              type="text"
                              value={email}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Email Address.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        lg={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="phone" className="form-group">
                          <InputGroup className="">
                            <img
                              src={imgCDNURL + "phone.webp"}
                              className="icon-phone"
                            />
                            <Form.Control
                              aria-label="Contact Number"
                              maxLength={21}
                              minLength={14}
                              onChange={handleTelephoneNumber}
                              pattern="^\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$"
                              placeholder="Contact Number:*"
                              required={contactNumberRequired}
                              type="text"
                              value={phone}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Contact Number.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="d-flex">
                          {showClickToMoreOpt ? (
                            <h6
                              className="consentSmall"
                              onClick={showPhoneSoliticationConsent}
                            >
                              {
                                "Do you consent to Automated Phone Solicitation?"
                              }{" "}
                              <span
                                id="showConsentText"
                                className="consentLink showConsentText"
                                title="Show Phone Solicitation Consent"
                              >
                                (click to show more)
                              </span>
                            </h6>
                          ) : (
                            <h6
                              className="consentSmall"
                              onClick={hidePhoneSoliticationConsent}
                            >
                              {
                                "Do you consent to Automated Phone Solicitation?"
                              }{" "}
                              <span
                                id="hideConsentText"
                                className="consentLink hideConsentText"
                                title="Hide Phone Solicitation Consent"
                              >
                                (click to show less)
                              </span>
                            </h6>
                          )}
                        </div>

                        {!showClickToMoreOpt ? (
                          <p
                            id="phoneSolicitationTerms"
                            className="consent-font pb-0"
                          >
                            By clicking I Consent below, you expressly consent
                            to Sun West Mortgage Company, Inc. making (or
                            allowing to be made on its behalf) a phone call,
                            text message or voicemail transmission to the phone
                            number you entered above for the purpose of
                            soliciting your purchase of consumer goods or
                            services (including using an automated system for
                            the selection or dialing of phone numbers, the
                            playing of a recorded message when a connection is
                            made, or the transmission of a pre-recorded
                            voicemail), even if that phone number is on a
                            national, state, or internal Do Not Call Registry.
                            You are not required to click on I Consent below
                            (directly or indirectly) or agree to receive such
                            phone calls, text messages, or voicemail
                            transmissions as a condition of obtaining any goods
                            or services from Sun West Mortgage Company, Inc. or
                            its affiliates.
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <Form.Check
                          aria-label="I Consent"
                          defaultChecked
                          className="checkIConsent"
                          id="iConsent"
                          label="I Consent"
                          name="checkIConsent"
                          onClick={() => setConsentValue(true)}
                          type="radio"
                        />
                        <Form.Check
                          aria-label="I DO NOT Consent"
                          className="checkIConsent"
                          id="iDoNotConsent"
                          label="I DO NOT Consent"
                          name="checkIConsent"
                          onClick={() => setConsentValue(false)}
                          type="radio"
                        />
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                        id="consentmargin"
                      >
                        <p className="consent-font">
                          By clicking Submit below you agree to Sun West
                          Mortgage Company, Inc.'s NMLS 3277 ("Sun West"){" "}
                          <a
                            href="https://www.swmc.com/terms-and-conditions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms and Conditions
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://www.swmc.com/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Security and Privacy Policy
                          </a>
                          ; and you agree to Celligence International, LLC.'s
                          ("Celligence"){" "}
                          <a
                            href="https://www.celligence.com/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms and Conditions
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://www.celligence.com/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Security and Privacy Policy
                          </a>
                          , all of which you may access by clicking on the
                          "Terms and Conditions" or "Security Policy" web links
                          contained herein.
                        </p>
                      </Col>

                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <div className="divflex">
                          <div>
                            <Button className="btn-submit" type="submit">
                              {formLoading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    aria-hidden="true"
                                    as="span"
                                    role="status"
                                    size="md"
                                  />{" "}
                                  Please wait...
                                </>
                              ) : (
                                <>Submit</>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Col>
                      {/* <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <p className="rulesText">
                          "This is an invite Only Event for Top Producers.<br /> Don't miss your chance & REGISTER NOW.<span className="rulessubText">(not all registrants will receive an invitation)</span>"
                        </p>
                      </Col> */}
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="divflex">
                          <div className="backBtnDiv">
                            <Button
                              className="btn-submit"
                              type="button"
                              onClick={goBackToFirstPage}
                            >
                              <>Back</>
                            </Button>
                          </div>
                          <div className="continueBtnDiv btnAdjustDiv">
                            <Button
                              className="btn-submit"
                              type="submit"
                              variant="success"
                            >
                              {formLoading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    aria-hidden="true"
                                    as="span"
                                    role="status"
                                    size="md"
                                  />{" "}
                                  Please wait...
                                </>
                              ) : (
                                <>Continue</>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Col>
            </Row>
          </Container>
          <Modal
            size="lg"
            centered
            show={showSuccessModal}
            onHide={handleSuccessClose}
            backdrop="static"
          >
            <Modal.Header closeButton />
            <Modal.Body className="text-center">
              <p className="thanktext">Thank You for the Feedback!</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleSuccessClose}>Close</Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            centered
            show={showFailModal}
            onHide={handleFailClose}
            backdrop="static"
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <p className="thanktext">
                Due to technical difficulties your request could not be
                processed. Please contact us at&nbsp;
                <a href={"mailto:inquiry@swmc.com"} className="form-link">
                  inquiry@swmc.com
                </a>
                .
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleFailClose}>Close</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
